import {pluralNumber} from './pluralNumber';

export const years = ( number ) => `${number} ${pluralNumber( number, 'год', 'года', 'лет' )}`;
